import { useCallback, useEffect } from "react";
import { useObservable } from "micro-observables";
import { useAsyncOperation } from "@core/hooks/use-async-operation";
import { LocaleManager } from "@domain/localization/locale-manager";



interface UseSupportedLocalesProps {
  localeManager: LocaleManager;
}

type UseSupportedLocales = {
  supportedLocales: Map<string, string[]>;
  fetchSupportedLocales: () => Promise<void>;
};

export const useSupportedLocales = ({ localeManager }: UseSupportedLocalesProps): UseSupportedLocales => {
  const supportedLocales = useObservable(localeManager.supportedLocales);

  const [fetchSupportedLocales] = useAsyncOperation(
    useCallback(() => localeManager.fetchSupportedLocales(), [localeManager]),
    {},
  );

  useEffect(() => {
    if (supportedLocales.size === 0) {
      fetchSupportedLocales();
    }
  }, [fetchSupportedLocales, supportedLocales]);

  return { supportedLocales, fetchSupportedLocales };
};
